import { footerData, siteName } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-background-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                {siteName}
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-[360px]">
              {footerData.description}
            </p>
          </div>

          {footerData.sections.map((section, i) => (
            <div key={i}>
              <h3 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
                {section.title}
              </h3>
              <ul className="space-y-2.5">
                {section.links.map((link, j) => (
                  <li key={j}>
                    <a
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-sm text-foreground-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 pt-6 md:pt-8 border-t border-foreground-700/30">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
              <span className="text-xs text-foreground-500">合作伙伴</span>
            </div>
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} {siteName} 版权所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}